interface SizeChart {
  headers?: string[];
  rows?: string[][];
}

interface Props {
  chart: SizeChart | null | undefined;
  imageUrl?: string | null;
}

export const SizeChartTable = ({ chart, imageUrl }: Props) => {
  const headers = Array.isArray(chart?.headers) ? chart!.headers : [];
  const rows = Array.isArray(chart?.rows) ? chart!.rows : [];
  const hasTable = rows.length > 0;

  if (!imageUrl && !hasTable) {
    return <p className="text-sm text-muted-foreground">Size chart not available for this product.</p>;
  }

  return (
    <div className="space-y-5">
      {imageUrl && (
        <a
          href={imageUrl}
          target="_blank"
          rel="noreferrer"
          className="block overflow-hidden rounded-xl border bg-secondary/30"
        >
          <img
            src={imageUrl}
            alt="Size chart"
            loading="lazy"
            className="w-full h-auto object-contain max-h-[520px]"
          />
        </a>
      )}

      {hasTable && (
        <div className="overflow-x-auto rounded-xl border">
          <table className="w-full text-sm">
            {headers.length > 0 && (
              <thead className="bg-muted/60">
                <tr>
                  {headers.map((h, i) => (
                    <th key={i} className="text-left px-4 py-3 font-semibold text-foreground">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
            )}
            <tbody className="divide-y">
              {rows.map((row, ri) => (
                <tr key={ri} className="hover:bg-muted/30">
                  {row.map((cell, ci) => (
                    <td key={ci} className="px-4 py-2.5">
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
